import styled from 'styled-components';
import { Expander as VendorExpander } from 'app/components';
import { textTransform } from 'utils';

export const AdvertisementWrapper = styled.div.attrs({
  className: 'advertisement-wrapper'
})`
  h2 {
    font-weight: 450;
    font-size: 24px;
    line-height: 34px;
    letter-spacing: 1.5px;
    text-transform: ${textTransform};
  }
  .advertisement-wrapper__cinema-wrapper {
    .advertisement-wrapper__cinema-content {
      margin: 24px 0 32px;

      a {
        font-weight: 390;
        font-size: 16px;
        line-height: 24px;
        color: #DE1619;
        text-decoration:underline;
      }
    }
  }

  .advertisement-wrapper__online-divider {
    border: 1px solid rgba(151, 151, 151, 0.8);
  }

  .advertisement-wrapper__online-wrapper {
    margin: 38px 0 32px;
    .advertisement-wrapper__online-content {
      margin-top: 24px;

      a {
        font-weight: 390;
        font-size: 16px;
        line-height: 24px;
        color: #DE1619;
        text-decoration:underline;
      }
    }
  }

  .advertisement-wrapper__press-divider {
    border: 1px solid rgba(151, 151, 151, 0.8);
  }

  .advertisement-wrapper__press-wrapper {
    margin: 39px 0 32px;

    .advertisement-wrapper__press-content {
      margin-top: 24px;

      a {
        font-weight: 390;
        font-size: 16px;
        line-height: 24px;
        color: #DE1619;
        text-decoration:underline;
      }
    }

    .advertisement-wrapper__press-info-wrapper {
      margin: 24px 0;

      h2 {
        font-weight: 450;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 1px;
      }

      .advertisement-wrapper__press-info-content {
        margin-top: 24px;

        .advertisement-wrapper__press-info-item {
          border-top: 1px solid #323232;
          padding: 10px 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          h3 {
            font-weight: 390;
            font-size: 18px;
            line-height: 20px;
          }
        }
        &:last-child {
          .advertisement-wrapper__press-info-item {
            border-bottom: 1px solid #323232;
          }
        }
      }
    }
  }
`;

export const Title = styled.h1`
  display: inline-block;
  vertical-align: middle;
  font-size: 2.4rem;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: ${textTransform};
  color: ${({ theme }) => theme.color.textPrimary};
  margin: 29px 0 30px 0;
`;

export const Expander = styled(VendorExpander)`
  background: #2d2d2d;
  padding: 0 16px;

  ul {
    margin: 10px 0;
    & > li {
      margin-top: 24px;
      width: 100%;

      h3 {
        font-weight: 390;
        font-size: 16px;
        line-height: 24px;
        text-transform: ${textTransform};
      }

      a {
        margin-top: 9px;
        font-weight: 390;
        font-size: 16px;
        line-height: 24px;
        color: #DE1619;
        text-decoration:underline;
      }
    }
    & > li:first-child {
      margin-top: 0;
    }
  }
`;
